import axios from "axios";
import store from "../store/store";
import { logout, setShowLogoutModal } from "../features/auth/user.reducer";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 10000,
  timeoutErrorMessage:
    "Request taking longer than expected. Check your network",
  headers: {
    "Content-Type": "application/json",
    Authorization: process.env.REACT_APP_AUTH_TOKEN_DEV,
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = JSON.parse(localStorage.getItem("token"));
    console.log("token", token);
    if (token) {
      config.headers.jwt = token;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => {
    if (response.data?.status === "Fail") {
      if (
        response?.data.status_code === 304 ||
        response?.data.message === "jwt token is not valid"
      )
        store.dispatch(setShowLogoutModal(true));

      const error = new Error();
      error.response = {
        ...response,
        data: response.data,
        status: 400,
      };
      return Promise.reject(error);
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      store.dispatch(logout());
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
